import request from '@/utils/request'

export function getAll() {
  return request({
    url: 'cost-center/getAll',
    method: 'get'
  })
}